//import createCachedSelector from 're-reselect';
//import { createSelector } from 'reselect';

const selectEventsDownloading = state => state.resultDownloadStore.eventsDownloading;

export const selectors = {
    selectEventsDownloading
}